import { createContext, useCallback, useContext, useState } from 'react';

const InquiryModalContext = createContext({
  isOpen: false,
  serviceId: null,
  open: () => {},
  close: () => {}
});

export function InquiryModalProvider({ children }) {
  const [state, setState] = useState({ isOpen: false, serviceId: null });

  const open = useCallback((serviceId = null) => {
    setState({ isOpen: true, serviceId });
  }, []);

  const close = useCallback(() => {
    setState({ isOpen: false, serviceId: null });
  }, []);

  return (
    <InquiryModalContext.Provider value={{ isOpen: state.isOpen, serviceId: state.serviceId, open, close }}>
      {children}
    </InquiryModalContext.Provider>
  );
}

export function useInquiryModal() {
  return useContext(InquiryModalContext);
}
